import { ShieldX } from "lucide-react";
import styles from "./no-permission-view.module.scss";

const CustomNoPermissionView = () => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.iconContainer}>
				<div className={styles.iconBg}>
					<ShieldX className={styles.icon} />
				</div>
				<div className={styles.pulse} />
			</div>
			<h2 className={styles.title}>Acceso restringido</h2>
			<p className={styles.message}>No tienes permisos para visualizar esta sección. Si crees que esto es un error, contacta con tu administrador.</p>
		</div>
	);
};

export default CustomNoPermissionView;
